export class Car {
  public id: string;
  constructor(obj?: any) {
    if (obj) {
      this.id = obj.id;
    }
  }
}
